import { ShieldCheck, HardHat, SearchCheck, Wrench, Scale } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";
import { DISTINTIVOS } from "../data/content";

const ICONS = [ShieldCheck, HardHat, SearchCheck, Wrench, Scale];

export const Distintivos = () => (
  <section
    id="distintivos"
    data-testid="distintivos-section"
    className="relative bg-cream py-20 sm:py-28 lg:py-36"
  >
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <SectionHead
        num="02"
        eyebrow="Por qué Oesca"
        title="Nuestros distintivos como organización"
        testId="distintivos-head"
      />

      <div className="mt-16 grid gap-5 md:grid-cols-2 lg:grid-cols-3">
        {DISTINTIVOS.map((d, i) => {
          const Icon = ICONS[i];
          return (
            <Reveal key={d.title} delay={0.08 * i} className={i === 4 ? "md:col-span-2 lg:col-span-1" : ""}>
              <article
                data-testid={`distintivo-card-${i + 1}`}
                className="group relative h-full overflow-hidden border border-cafe-line bg-white p-8 transition-[border-color,transform,box-shadow] duration-500 hover:-translate-y-1.5 hover:border-cafe hover:shadow-2xl hover:shadow-cafe-dark/10"
              >
                <span
                  aria-hidden="true"
                  className="pointer-events-none absolute -right-3 -top-6 select-none font-display text-8xl font-semibold text-cafe-dark/5 transition-colors duration-500 group-hover:text-cafe/10"
                >
                  {String(i + 1).padStart(2, "0")}
                </span>
                <div className="relative">
                  <div className="flex h-12 w-12 items-center justify-center border border-cafe-line bg-cream transition-colors duration-500 group-hover:border-cafe group-hover:bg-cafe">
                    <Icon className="h-5 w-5 text-cafe-dark transition-colors duration-500 group-hover:text-white" />
                  </div>
                  <span className="mt-6 block font-mono text-[10px] font-semibold tracking-[0.3em] text-cafe">
                    {String(i + 1).padStart(2, "0")} / 05
                  </span>
                  <h3 className="mt-3 font-display text-xl font-semibold leading-snug text-cafe-dark sm:text-2xl">
                    {d.title}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-cafe-muted">{d.text}</p>
                </div>
              </article>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
